module.exports = __webpack_public_path__ + "static/media/新瓦力机器人-PNG.33621378.png";